






































import vue from "vue";

import ExerciseMiniSettings from "@tt-app/components/exercise/consolidated/exercise/footer/ExerciseMiniSettings.vue";
import IconSettings from "@joyz/app-core/assets/icons/black/Settings.png";
import IconSkip from "@joyz/app-core/assets/icons/black/ChevronRight.svg";

interface Data {
  icons: {
    [name: string]: string;
  };
}

interface Methods {
  handleMiniSettingsClick: () => void;
  handleSkipClick: () => void;
}

interface Computed {
  hasAnsweringUi: boolean;
  hasExtendedAnsweringUi: boolean;
}

interface Props {
  disabled: boolean;
  hideSettings: boolean;
  hideSkip: boolean;
}

export default vue.extend<Data, Methods, Computed, Props>({
  name: "BaseExerciseFooter",

  components: { ExerciseMiniSettings },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hideSettings: {
      type: Boolean,
      default: false
    },
    hideSkip: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      icons: {
        settings: IconSettings,
        skip: IconSkip
      }
    };
  },

  methods: {
    handleMiniSettingsClick() {
      this.$emit("settings-click");
    },

    handleSkipClick() {
      this.$emit("skip-click");
    }
  },

  computed: {
    hasAnsweringUi() {
      const slotContents = this.$slots["answering-ui"];

      if (slotContents) {
        return slotContents.length > 0;
      }

      return false;
    },

    hasExtendedAnsweringUi() {
      const slotContents = this.$slots["extended-answering-ui"];

      if (slotContents) {
        return slotContents.length > 0;
      }

      return false;
    }
  }
});
